import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loader: false,
  toastInfo: {},
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showToast: (state, action) => {
      state.toastInfo = action.payload;
    },
  },
});

export const { showToast } = toastSlice.actions;

export default toastSlice.reducer;
